import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.workspace.nav');
import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-workspace-nav',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.workspace.nav/view.scss */
:host {
  display: block;
}

.nav-item {
  transition: color 180ms ease-out, background-color 180ms ease-out;
}

.nav-item:active {
  background: var(--ui-nav-active);
}

.nav-item.selected:active {
  background: var(--ui-nav-selected-pressed);
}

@media (prefers-reduced-motion: reduce) {
  .nav-item {
    transition: none;
  }
}`],
})
export class ComponentWorkspaceNavComponent implements OnInit {
    @Input() user: any = null;
    @Output() navigated = new EventEmitter<string>();
    readonly items = [
        {label: '홈', path: '/', fragment: null, target: 'dashboard-top', icon: 'fa-solid fa-table-cells-large', restricted: false},
        {label: '문헌 관리', path: '/sources', fragment: null, target: '', icon: 'fa-regular fa-folder-open', restricted: true},
        {label: '데이터셋', path: '/datasets', fragment: null, target: '', icon: 'fa-solid fa-layer-group', restricted: true, authoring: true},
        {label: '지식 관리', path: '/knowledge-graph', fragment: null, target: '', icon: 'fa-solid fa-diagram-project', restricted: true, authoring: true},
        {label: '선호도 평가', path: '/dpo', fragment: null, target: '', icon: 'fa-solid fa-scale-balanced', restricted: true, authoring: true},
        {label: '작업 현황', path: '/', fragment: 'jobs', target: 'jobs', icon: 'fa-regular fa-clock', restricted: true}
    ];
    readonly adminItems = [
        {label: '운영 현황', tab: 'overview', path: '/admin', fragment: null, target: '', restricted: true, adminOnly: true},
        {label: '사용자 및 권한', tab: 'users', path: '/admin', fragment: null, target: '', restricted: true, adminOnly: true},
        {label: '검토 및 평가 관리', tab: 'reviews', path: '/admin', fragment: null, target: '', restricted: true, adminOnly: true}
    ];
    isSelected(item:any) {
        const url = this.router.url || '/';
        const path = url.split(/[?#]/)[0];
        if (this.canReviewDatasets && path === '/') return item.path === '/' && !item.fragment;
        if (item.path === '/') return path === '/' && (item.fragment === 'jobs' ? url.split('#')[1] === 'jobs' : url.split('#')[1] !== 'jobs');
        return path === item.path || (item.path === '/knowledge-graph' && path === '/knowledge-map');
    }
    get canManage() {return this.user?.role==='admin' && this.user?.status==='active';}
    isAdminSelected(tab:string) {
        if(!this.canManage || this.router.url.split(/[?#]/)[0]!=='/admin')return false;
        const requested=new URLSearchParams((this.router.url.split('?')[1]||'').split('#')[0]).get('tab')||'overview';
        return (['overview','users','reviews'].includes(requested)?requested:'overview')===tab;
    }
    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) {}
    async ngOnInit() { await this.service.init(); }
    get canReviewDatasets() {return this.user?.status==='active' && this.user?.role==='reviewer';}
    itemLabel(item:any) {return this.canReviewDatasets && item.path==='/datasets' ? 'QA 검수' : item.label;}
    canOpen(item:any) {
        if (item.adminOnly) return this.canManage;
        if (this.canReviewDatasets) return !item.fragment && ['/','/datasets','/dpo'].includes(item.path);
        if (item.restricted) return this.canAuthor;
        return true;
    }
    get canAuthor() { return this.user?.status === 'active' && ['admin', 'researcher'].includes(this.user.role); }
    get canBrowse() { return this.user?.status === 'active' && ['admin', 'researcher', 'reviewer', 'external'].includes(this.user.role); }
}

export default ComponentWorkspaceNavComponent;